import { REDO_SELECTOR_PICKER_STORAGE_KEY } from "@redotech/redo-storefront-web/cache/keys";
import {
  getSessionStorageWithExpiry,
  setSessionStorageWithExpiry,
} from "@redotech/redo-web/utils/session-storage-wrapper";
import { inIframe } from "../coverage-builder/coverage-builder-init";

const SELECTOR_PICKER_QUERY_PARAM = "redo-selector-picker";
const SELECTOR_PICKER_MODE_TTL_MINUTES = 5;

/** Generic sibling of `inCoverageBuilderMode`: true when a settings surface is
 *  embedding the storefront in an iframe to point-and-click a selector. */
export function inSelectorPickerMode(): boolean {
  const persisted = getSessionStorageWithExpiry(
    REDO_SELECTOR_PICKER_STORAGE_KEY,
  );
  const queryParameters = new URLSearchParams(location.search);
  const hasQueryParam = queryParameters.has(SELECTOR_PICKER_QUERY_PARAM);

  if ((!hasQueryParam && !persisted) || !inIframe()) {
    return false;
  }

  if (!persisted) {
    setSessionStorageWithExpiry(
      REDO_SELECTOR_PICKER_STORAGE_KEY,
      true,
      SELECTOR_PICKER_MODE_TTL_MINUTES,
    );
  }

  return true;
}
